import { render, staticRenderFns } from "./TransHoldpage.vue?vue&type=template&id=b6d8479c&scoped=true"
import script from "./TransHoldpage.vue?vue&type=script&lang=js"
export * from "./TransHoldpage.vue?vue&type=script&lang=js"
import style0 from "./TransHoldpage.vue?vue&type=style&index=0&id=b6d8479c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8479c",
  null
  
)

export default component.exports